import { useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import api from "@/lib/api";

const RACE_FIELDS = ["title", "description", "date", "location", "organiser", "distances", "registration_url", "entry_fee", "image", "pitch", "map_url"];

/** Inline editor for a race's "join us" pitch (Admin → Races list). */
export default function RacePitchEditor({ race, onSaved }) {
  const [editing, setEditing] = useState(false);
  const [pitch, setPitch] = useState(race.pitch || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const body = Object.fromEntries(RACE_FIELDS.map((k) => [k, race[k] ?? ""]));
      await api.put(`/races/${race.race_id}`, { ...body, pitch: pitch.trim() });
      toast.success("Pitch saved");
      setEditing(false);
      onSaved?.();
    } catch { toast.error("Save failed"); }
    finally { setBusy(false); }
  };

  if (!editing) {
    return (
      <button
        type="button"
        data-testid={`admin-race-pitch-edit-${race.race_id}`}
        onClick={() => setEditing(true)}
        className="block text-left mt-2 text-xs text-zinc-300 italic hover:text-white group"
      >
        {race.pitch ? <>“{race.pitch}”</> : <span className="text-zinc-500 not-italic">+ Add a join-us pitch for the Welcome Board</span>}
        <span className="font-mono text-[9px] tracking-[0.2em] uppercase text-orange-500 ml-2 opacity-0 group-hover:opacity-100 transition not-italic">EDIT</span>
      </button>
    );
  }

  return (
    <div className="mt-2 space-y-2" data-testid={`admin-race-pitch-form-${race.race_id}`}>
      <Textarea
        data-testid={`admin-race-pitch-input-${race.race_id}`}
        value={pitch}
        onChange={(e) => setPitch(e.target.value)}
        rows={2}
        placeholder="Let's take 25 OSCR runners to this one — book before slots run out!"
        className="rounded-none bg-zinc-950 border-zinc-800 text-white text-sm focus-visible:ring-orange-600"
      />
      <div className="flex gap-2">
        <button type="button" data-testid={`admin-race-pitch-save-${race.race_id}`} onClick={save} disabled={busy}
          className="font-display text-xs tracking-wider px-3 py-1.5 bg-orange-600 hover:bg-orange-500 text-white disabled:opacity-60">
          SAVE
        </button>
        <button type="button" onClick={() => { setEditing(false); setPitch(race.pitch || ""); }}
          className="font-display text-xs tracking-wider px-3 py-1.5 border border-zinc-700 text-zinc-300 hover:text-white">
          CANCEL
        </button>
      </div>
    </div>
  );
}
